import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Url } from '@wix/da-url';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { getPromo } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { canPerformPageAction } from '../../../../selectors/groups';
import { AppState } from '../../../../../types/store';
import { PagePriv } from '../../../../../types/pagePrivileges';
import { isViewingAsVisitor } from '../../../../selectors/users';
import { getActiveSection } from '../../../../selectors/sections';
import { viewProfileAsVisitor } from '../../../../actions/profileOwner';
import { Props } from './SubNavBarDesktopInner';

type StateProps = Pick<Props, 'canViewAsVisitor' | 'isPromoActive'>;
type DispatchProps = Pick<Props, 'viewAsVisitor' | 'showBlockModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  canViewAsVisitor:
    !isViewingAsVisitor(state) && getActiveSection(state) !== 'stats',
  canRespondToGroupNotifications: canPerformPageAction(
    state,
    PagePriv.CAN_RESPOND_TO_GROUP_NOTIFICATIONS
  ),
  isPromoActive: !!getPromo(state, 'core_gift_sale_on_profiles'),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  viewAsVisitor: toggle => dispatch(viewProfileAsVisitor(toggle)),
  showBlockModal: () =>
    dispatch(
      pushModal(ModalType.USER_BLOCK, {
        wrapInModal: true,
        params: {
          user: ownProps.profileOwnerUser,
          redirectLocation: Url.browseHomeLink(),
        },
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
